<template>
    <v-card title="Felhasználók" flat>
        <template>
            <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" variant="outlined"
                hide-details single-line></v-text-field>
        </template>

        <v-data-table :headers="headers" :items="items" :search="search">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="me-2" size="large" @click="getUserInfo()">
                    mdi-pencil
                </v-icon>
                <v-icon size="large" @click="deleteItem(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
export default {
    name: "Admin",
    methods: {
        deleteItem: function (item) {
            console.log(item)
            this.items.pop(item)
        },
        editItem: function (item) {
            console.log(item)
        },
        async getUserInfo() {
            const response = await fetch('/.auth/me');
            const payload = await response.json();
            const { clientPrincipal } = payload;
            console.log(clientPrincipal)
        }
    },
    data() {
        return {
            search: '',
            headers: [
                {
                    align: 'start',
                    value: 'id',
                    text: 'Id',
                },
                { value: 'name', text: 'Név' },
                { value: 'rank', text: 'Jogosultság' },
                { value: 'actions', text: 'Műveletek', sortable: false }
            ],
            items: [
                { id: 1, name: 'TEST_ADMIN', rank: 'ADMIN' },
                { id: 2, name: 'TEST_USER', rank: 'USER' },
                { id: 3, name: 'TEST_HALF_ADMIN', rank: 'PART_ADMIN' },
            ]
        }
    }
}
</script>